import React, { Component } from 'react';
import { getNewsletterSubscribersList, removeNewsletterSubscriberItem, sendEmailToNewsletterSubscribers , sendEmailToStoreSubscribers} from '../../modules/Api';
import { notification, Button } from 'antd';
import ReactTable from 'react-table';
import moment from 'moment-jalaali';
import Email from '../../components/Email';
import history from '../../modules/History';
import ACL from '../../components/ACL';

class Newsletter extends Component {
    constructor() {
        super();
        this.state = {
            items: [],
            email: '',
            status: 1,
            visibleModal: false,
            general : false,
            emailState: Email.initialState(),
            pageSize: 15,
            count: 0,
            last_page: 1,
        }
    }

    fetchData = (query=``) => {
        getNewsletterSubscribersList(query, (data) => {this.setState({
            items: data.data,
            count: data.total,
            last_page: data.last_page,
            pageSize: data.per_page
        })});
    }

    onChange(state) {
        this.setState({pageSize: state.pageSize});
        let sort = "";

        if(state.sorted && state.sorted.length > 0) {
            sort = JSON.stringify({
                item: state.sorted[0].id,
                desc: state.sorted[0].desc
            });
        }

        const email  = state.filtered.find(f => f.id === 'email') ? state.filtered.find(f => f.id === 'email').value : '';
        const status = state.filtered.find(f => f.id === 'status') ? state.filtered.find(f => f.id === 'status').value : '';

        const query  = `page=${state.page  + 1}&per_page=${state.pageSize}&filter[email]=${email}&filter[status]=${status}&sort=${sort}`;

        this.fetchData(query);
    }

    removeItem(id) {
        const warningMessage = `آیا از حذف اطمینان کامل دارید ؟  !`;
        if (window.confirm(warningMessage)) {
            removeNewsletterSubscriberItem(id, () => {
                this.fetchData();
                notification.open({
                    message: `آیتم با موفقیت حذف شد!`
                })
            })
        }
    }

    openModal(event) {
        this.setState({visibleModal: true});
        event.target.id == 'general' ? this.state.general = true : this.state.general = false;
    }

    commitModalChanges(data) {
        const payload = {
            email: data,
            filter: {
            }
        };
        notification.open({message: `اطلاعات در حال ارسال است . لطفا منتظر بمانید ...`});
        if (this.state.general){
            sendEmailToStoreSubscribers(payload, (data) => {
                notification.open({message: data.message});
            });
        }else{
            sendEmailToNewsletterSubscribers(payload, (data) => {
                notification.open({message: data.message});
            });
        }
        this.closeModal();
    }

    closeModal() {
        this.setState({visibleModal: false});
    }

    render() {

        const columns = [
            {
                Header: 'آیدی',
                accessor: 'id',
            },
            {
                Header: 'ایمیل',
                accessor: 'email',
                filterable: true,
                Cell: (row) => (<span title={row.original.email}> {row.original.email} </span>)
            },
            {
                Header: 'خبرنامه‌ها',
                accessor: 'count.newsletters',
                Cell: (row) => (<span title={row.original.count.newsletters}> {row.original.count.newsletters} </span>)
            },
            {
                Header: 'ارسال شده',
                accessor: 'count.sent',
                Cell: (row) => (<span title={row.original.count.sent}> {row.original.count.sent} </span>)
            },
            {
                Header: 'مشاهده',
                accessor: 'count.viewed',
                Cell: (row) => (<span title={row.original.count.viewed}> {row.original.count.viewed} </span>)
            },
            {
                Header: 'کلیک',
                accessor: 'count.clicked',
                Cell: (row) => (<span title={row.original.count.clicked}> {row.original.count.clicked} </span>)
            },
            {
                Header: 'تاریخ ایجاد',
                accessor: 'created_at',
                Cell: (row) => (<span>{
                    row.original.created_at
                    ? moment(row.original.created_at).format('jYYYY/jMM/jDD')
                    : null
                }</span>)
            },
            {
                Header: 'وضعیت',
                accessor: 'status',
                filterable: true,
                Cell: (row) => (
                <div title={row.original.status === 2 ? 'غیر‌فعال' : 'فعال'} style={{width:100+'%', textAlign:'center'}}>
                    <span style={{padding:0 + 2+'rem',backgroundColor: row.original.status === 2 ? '#f5222d' : '#52c41a',}}>
                        {row.original.status === 2 ? 'غیر‌فعال' : 'فعال'}
                    </span>
                </div>
                ),
            },
            {
                Header: 'حذف',
                accessor: 'delete',
                Cell: (row) => (
                    <React.Fragment>
                        <ACL component="span" has_permission="newsletter_management|newsletter_delete"><span onClick={() => {this.removeItem(row.original.id)}} className="fa fa-trash" style={{color: 'tomato', cursor: 'pointer', marginTop: '20%'}} >X </span></ACL>
                        <ACL component="span" has_permission="newsletter_management|newsletter_history"><span onClick={() => history.item.push(`/history/newsletter/${row.original.id}`)} className="link">H</span></ACL>
                    </React.Fragment>
                )
            },
        ];
        let table;
        table = (
            <ReactTable
                data={this.state.items}
                columns={columns}
                onFetchData={state => this.onChange(state)}
                manual
                defaultPageSize={this.state.pageSize}
                pages={this.state.last_page}/>
        );
    return(
            <div style={{textAlign: 'center'}}>
                <b>تعداد کل : {this.state.count}</b>
                <div className="btn-container">
                    <ACL component="span" has_permission="newsletter_management|newsletter_add"><Button
                        type="primary"
                        htmlType="button"
                        onClick={this.openModal.bind(this)}>
                        ارسال ایمیل
                    </Button></ACL>
                    <ACL component="span" has_permission="newsletter_management|newsletter_add|subscribers_management|subscribers_add"><Button
                        type="primary"
                        htmlType="button"
                        id="general"
                        onClick={this.openModal.bind(this)}>
                        ارسال ایمیل به کاربران و فروشگاه ها
                    </Button></ACL>

                    <ACL component="span" has_permission="newsletter_management|newsletter_history"><Button type="secondary" onClick={() => history.item.push(`/history/newsletter`)}>تاریخچه</Button></ACL>
                </div>
                <br />
                وضعیت
                2:‌ غیر‌فعال
                1: فعال
                <br />
                <Email
                    visible={this.state.visibleModal}
                    open={this.openModal.bind(this)}
                    close={this.closeModal.bind(this)}
                    commit={this.commitModalChanges.bind(this)}/>
                {table}
            </div>
        );
    }
}

export default Newsletter;


// WEBPACK FOOTER //
// ./src/containers/Newsletter/index.js